import type {LogEntry} from '../types/session'
import {isCompletionUserMessage} from '../types/session'

const AGENT_INSTRUCTIONS_PATTERN = /<agent_instructions>([\s\S]*?)<\/agent_instructions>/

/**
 * Extracts the content between `<agent_instructions>` tags from the first
 * user message in a session's log entries. These tags wrap the custom
 * instructions a user supplies when assigning Copilot to an issue.
 */
export function extractAgentInstructions(logEntries: LogEntry[] | undefined | null): string | null {
  if (!logEntries?.length) return null

  for (const entry of logEntries) {
    if (!isCompletionUserMessage(entry)) continue

    const content =
      typeof entry.content === 'string' ? entry.content : entry.content?.map(c => ('text' in c ? c.text : '')).join('')

    if (!content) continue

    const match = content.match(AGENT_INSTRUCTIONS_PATTERN)
    if (match?.[1]) {
      return match[1].trim()
    }
  }

  return null
}
